import React, { RefObject } from 'react'
import { Platform, View, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'
import { Question } from './question'
import { QuestionTitle } from './question-title'
import { QuestionType } from '../types/question'
import { Node } from '../types/node'

type QuestionGroupProps = {
  /** The questions for the question group. */
  questions: Array<QuestionType>,
  /** The question title */
  question: string,
  /** The primary color of the app. */
  accentColor: string,
  /** The id of the active answer to the question. */
  active: string | null,
  /** A ref to the view. */
  viewRef?: object,
  /** Key identifier */
  keyID: number,
  /** The node path to the chair. */
  path?: Array<Node>,
  /** Called when an answer is clicked. */
  onAnswerChange: Function,
  extraAttributes: Object,
}

/**
 * A question and a group of answers
 * @component
 */
export class QuestionGroup extends React.Component<QuestionGroupProps> {
  static propTypes = {
    questions: PropTypes.array.isRequired,
    question: PropTypes.string.isRequired,
    accentColor: PropTypes.string.isRequired,
    active: PropTypes.string,
    viewRef: PropTypes.object,
    keyID: PropTypes.number.isRequired,
    path: PropTypes.array,
    onAnswerChange: PropTypes.func.isRequired,
    extraAttributes: PropTypes.object.isRequired,
  }

  render() {
    return (
      <View style={styles.container}
        ref={this.props.viewRef as RefObject<View>}
        collapsable={false}
        onLayout={() => {}}
      >
        <QuestionTitle title={this.props.question} />
        <View style={styles.questionContainer}>
          {
            this.props.questions
              ?.sort((a, b) => a.index - b.index)
              ?.map((question, key) => {
              //console.log(question)
              if (question.name == this.props.extraAttributes.hideProduct) {
                return
              }
              return (
              <Question
                key={key}
                id={question.id}
                name={question.name}
                attributes={question.attributes}
                type={question.type}
                accentColor={this.props.accentColor}
                active={this.props.active === question.id || this.props.path?.map((node: any) => node.id).includes(question.id)}
                onClick={(e: MouseEvent) => this.props.onAnswerChange(e, this.props.keyID)}
              />
              )
              }
            )
          }
        </View>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  questionContainer: {
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '95%',
    borderColor: '#ddd',
    borderWidth: 2,
    borderRadius: 10,
    margin: 20,
  }
})
